import { GraphQLError } from 'graphql';

const invalidTokenErrors = ['Unauthorized', 'Access token expired'];

export const isInvalidTokenError = (
  graphQLErrors: readonly GraphQLError[] | undefined,
) =>
  (graphQLErrors || []).some(({ message }: { message?: string }) =>
    invalidTokenErrors.some(invalidTokenErr =>
      message?.includes(invalidTokenErr),
    ),
  );
